import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const quantumeldConfig: TSPConfig = {
  key: 'quantumeld',
  name: 'QuantumELD',
  category: TSPCategory.API_KEY,
  helpText: 'Please enter your QuantumELD API key to connect your account.',
  loginComponent: (props) => (
    <LoginCreds
      fields={[{ name: 'apikey', label: 'Enter API key' }]}
      onValidityChange={props.onValidityChange}
    />
  ),
};

export default quantumeldConfig;
